<template>
	<div>
		<div data-v-74b22936="" class="main main_fullscreen">
			<div data-v-74b22936="" class="exam">
				<div class="left-side">
					<!-- <div style="background-color: #fff;">
						<el-button style="background-color: #4c7bff;" type="primary" size="small" icon='el-icon-refresh'
							@click="toLogin">切换试卷</el-button>
					</div> -->
					<div class="timer">
						<div class="timer">
							<img src="data:image/webp;base64,UklGRrYBAABXRUJQVlA4TKkBAAAvL8ALEKcQ8x8G2UZO/RGsCB8u8DJkMplMAIAY21ZV59ybhEgeGrx399+sH9AKIvo/ARq38rdFAtH/iutpWzqDe/EnbElmNp+2JOfRW2tbzzNY5vjOMVsxXXpZTwif8JMAWU2DXgIgv4cWjtU0s3JcBhaA+NJkD4Dl1jfAappuG8DPDU9g1aMrkH4VwKaHV2C/WICwAVv+bMACqCcO4Bps0Ab0BaQdGlA12qGPqAJVkgOhN1hCmlSA8gpVoEo74O+whC4Hmt6hFbAClLcUoHwAf4sBnw6ptyjgP6C/p0MA/+9ZIYE2wWPecYIHD+QMDyB8xgYE9BEPIFwzO8QGMeABhGtqQv8AdssDCNdUBz4FKHc8gHDNLUAxoN3wAMI1uQGuDmkXHkC4JjuwSxWoFx0I1+wCFMkS0m6Ea3oALqkC9cx7d01fgCZJlsDXybMb4AdVIOy5X6g634H2nNx16Qm0524XgM1epAoQ/iJVjssUW3qZoe8EiOIjtiRgM+TBaSt+ZaUlR58i1RMg+9Za68F5/mq2r2eDWU0PetlHejU97eXTA8jYPsU0DgA="
								class="timer-icon">
							<div class="timer-text">{{ formattedTime }}</div>
						</div>
					</div>
					<div class="question-list">
						<div class="question-list-area">
							<div class="question-grid">
								<!-- <div class="question-card question-card_active">1</div> -->
								<div class="question-card" @click="chooseIndex = index"
									:class="chooseIndex == index ? 'question-card_active' : item.qanswer && item.answer_num == 1 ? 'question-card_done' : item.answer_num != 1 && item.qanswer.length > 0 ? 'question-card_done' : ''"
									v-for="(item, index) in list" :key="index">
									{{ index + 1 }}
								</div>
							</div>
						</div>
						<div>
							<div class="sumit-button" @click="saveQuestion">提交试卷</div>
						</div>
					</div>
				</div>
				<div class="answer-area" v-if="list[chooseIndex]">
					<div class="answering-area">
						<div v-show="list[chooseIndex]['question_type'] == 1" @click="imgChange(list[chooseIndex]['question'])">
							<el-image class="question-img" fit="scale-down"
								:src="list[chooseIndex]['question']"></el-image>
						</div>
						<div v-show="list[chooseIndex]['question_type'] == 2" v-html="list[chooseIndex]['question']"
							style="font-size: 16px !important;padding: 20px;line-height: 1.75;">

						</div>
						<div v-if="list[chooseIndex].question_choose.length > 0">
							<div class="answering">
								<div class="answering-choice" @click="chooseItem(item)"
									v-for="(item,index) in list[chooseIndex].question_choose" :key="index"
									:class="list[chooseIndex]['qanswer'].indexOf(item) != -1 ? 'answering-choice_active' : ''">
									{{item}}
								</div>
							</div>
						</div>
						<div v-else>
							<div class="answering" v-if="list[chooseIndex].answer_num == 1">
								<div class="answering-choice" @click="chooseItem('A')"
									:class="list[chooseIndex]['qanswer'] == 'A' ? 'answering-choice_active' : ''">A
								</div>
								<div class="answering-choice" @click="chooseItem('B')"
									:class="list[chooseIndex]['qanswer'] == 'B' ? 'answering-choice_active' : ''">B
								</div>
								<div class="answering-choice" @click="chooseItem('C')"
									:class="list[chooseIndex]['qanswer'] == 'C' ? 'answering-choice_active' : ''">C
								</div>
								<div class="answering-choice" @click="chooseItem('D')"
									:class="list[chooseIndex]['qanswer'] == 'D' ? 'answering-choice_active' : ''">D
								</div>
							</div>
							<div class="answering" v-if="list[chooseIndex].answer_num != 1">
								<div class="answering-choice" @click="chooseItem('A')"
									:class="list[chooseIndex]['qanswer'].indexOf('A') != -1 ? 'answering-choice_active' : ''">
									A</div>
								<div class="answering-choice" @click="chooseItem('B')"
									:class="list[chooseIndex]['qanswer'].indexOf('B') != -1 ? 'answering-choice_active' : ''">
									B</div>
								<div class="answering-choice" @click="chooseItem('C')"
									:class="list[chooseIndex]['qanswer'].indexOf('C') != -1 ? 'answering-choice_active' : ''">
									C</div>
								<div class="answering-choice" @click="chooseItem('D')"
									:class="list[chooseIndex]['qanswer'].indexOf('D') != -1 ? 'answering-choice_active' : ''">
									D</div>
							</div>
						</div>
						<div class="pre-next">
							<div style="padding-right:10px;font-size: 1.56rem;color:red">
								({{list[chooseIndex].answer_num != 1 ? '不定项' : '单选'}})</div>
							<div class="pre-next-button pre-button" @click="lastAnswer" v-if="chooseIndex > 0">上一题</div>
							<div class="pre-next-button next-button" @click="nextAnswer"
								v-if="chooseIndex < list.length - 1">下一题</div>
						</div>
						<div style="height: 1.5rem;"></div>
					</div>
				</div>
				<el-dialog title="考试信息确认" :visible.sync="dialogVisible" width="60%" :show-close="false"
					:close-on-click-modal="false" :close-on-press-escape="false">
					<!-- {{ info }} -->
					<div class="exam-start-info">
						<div class="exam-start-info__item">
							<div class="exam-start-info-item__title">考试名称</div>
							<div class="exam-start-info-item__content">{{ info.name }}</div>
						</div>
						<div class="exam-start-info__item">
							<div class="exam-start-info-item__title">考试时间</div>
							<div class="exam-start-info-item__content" v-html="info.time_des"></div>
						</div>
						<div class="exam-start-info__item">
							<div class="exam-start-info-item__title">考试须知</div>
							<div class="exam-start-info-item__content" v-html="info.descript"></div>
						</div>
						<div class="start-button" @click="beginExam()">开始考试</div>
					</div>
					<!-- <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span> -->
				</el-dialog>
				<el-dialog title="提示" :visible.sync="outerVisible" fullscreen :show-close="false"
					:close-on-click-modal="false" :close-on-press-escape="false">
					<el-row>
						<el-col :sm="24" :lg="24">
							<el-result icon="error" title="错误提示" subTitle="考试已结束">
								<!-- <template slot="extra">
									<el-button type="primary" size="medium">返回</el-button>
								</template> -->
							</el-result>
						</el-col>
					</el-row>
				</el-dialog>
			</div>
		</div>
		<el-dialog :visible.sync="showImg" width="60%">
			<el-image style="width: 100%;" :src="imgUrl" fit="scale-down"></el-image>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				countdown: 10800, // 倒计时初始值（例如：60秒）
				intervalId: null,
				info: {},
				dialogVisible: false,
				loading: true,
				chooseIndex: 0,
				list: [],
				outerVisible: false,
				showChoose: true,
				showImg: false,
				imgUrl: ''
			}
		},
		computed: {
			pageData() {
				if (this.$store.state.pageData && this.$store.state.pageData.title) {
					document.title = this.$store.state.pageData.title;
				}
				return this.$store.state.pageData; // 访问Vuex Store的计数器状态
			},
			// 计算剩余时间并格式化为分钟和秒数
			formattedTime() {
				const minutes = Math.floor(this.countdown / 60);
				const seconds = this.countdown % 60;
				return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
			},
			countdownFinished() {
				return this.countdown <= 0;
			},
		},
		created() {
			this.examClass();
			this.getList();
		},
		methods: {
			// 切换试卷
			toLogin() {
				this.$router.push({
					path: '/Login',
					query: {
						type: 3
					}
				})
			},
			// 图片放大
			imgChange(url) {
				this.showImg = true;
				this.imgUrl = url;
			},
			// 获取配置
			examClass() {
				//exam_class
				this.$request.get('/sike.php/exam/exam_class').then(res => {
						if (res.code == 200) {
							this.info = res.data;
							let {
								start_time,
								time,
								status
							} = res.data;
							if (status == 1) {
								this.dialogVisible = true;
							} else if (status == 2) {
								this.$router.replace('/Result');
							}
						}
					})
					.catch(err => {
						this.loading = false
						console.error('请求失败:', err);
					});
			},
			// 获取题目列表
			getList() {
				this.$request.get('/sike.php/exam/questionList').then(res => {
						if (res.code == 200) {
							res.data.forEach((item, index) => {
								if (item.answer_num != 1) {
									if (item.qanswer) {
										item.qanswer = item.qanswer.split(",")
									} else {
										item.qanswer = []
									}
								}
							})
							this.list = res.data;
						}
					})
					.catch(err => {
						this.loading = false
						console.error('请求失败:', err);
					});
			},
			// 开始考试
			beginExam() {
				this.$request.get('/sike.php/exam/beginExam').then((res) => {
					if (res.code == 200) {
						// status考试状态0未开始1正在考试2已结束
						const currentTimestampInSeconds = Math.floor(Date.now() / 1000);
						let {
							countdown_time, //考试剩余时间吗，后台计算
							start_time, //开始考试时间
							time, //持续时间
							status
						} = res.data;
						if (status == 1) {
							this.startCountdown(); // 组件挂载后立即开始倒计时
							this.dialogVisible = false;
						} else if (status == 2) {
							this.$router.replace('/Result');
							this.outerVisible = true;
						}
						this.dialogVisible = false;
						this.countdown = countdown_time;
					}
				})
			},
			// 上一题
			lastAnswer() {
				if (this.chooseIndex > 0) {
					this.chooseIndex -= 1;
				}
			},
			// 下一题
			nextAnswer() {
				this.chooseIndex += 1;
			},
			chooseItem(answer) {
				if (!this.showChoose) {
					return
				}
				if (this.list[this.chooseIndex].answer_num == 1) {
					if (this.list[this.chooseIndex].qanswer == answer) {
						this.list[this.chooseIndex].qanswer = ''
					} else {
						this.list[this.chooseIndex].qanswer = answer;
					}
				} else {
					let index = this.list[this.chooseIndex]['qanswer'].indexOf(answer)
					if (index == -1) {
						this.list[this.chooseIndex]['qanswer'].push(answer)
					} else {
						this.list[this.chooseIndex]['qanswer'].splice(index, 1)
					}
				}
				this.showChoose = false;
				let params = {
					qid: this.list[this.chooseIndex]['id'],
					answer: this.list[this.chooseIndex].qanswer
				}
				if(this.list[this.chooseIndex].answer_num != 1){
					params.answer = this.list[this.chooseIndex].qanswer.join(',')
				}
				this.$request.post('/sike.php/exam/saveAnswer', params).then((res) => {
						if (res.code == 200) {
							this.showChoose = true;
						} else {
							this.$notify.error({
								title: '错误',
								message: res.message
							});
						}
					})
			},
			// 判断是否全部答完
			saveQuestion() {
				// chooseIndex < list.length - 1
				let hasEmptyValue = false;
				let list = this.list;
				for (let i = 0; i < list.length; i++) {
					if (!list[i].qanswer) {
						hasEmptyValue = true;
						break;
					}
				}
				if (hasEmptyValue) {
					this.$confirm('还有未完成题目, 是否确认交卷?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.saveQuestionPost();
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消操作'
						});
					});
				} else {
					this.saveQuestionPost();
				}
				return;
			},
			// 交卷
			saveQuestionPost() {
				this.$request.post('sike.php/exam/saveQuestion').then((res) => {
					if (res.code == 200) {
						this.$notify({
							title: '成功',
							message: '交卷成功',
							type: 'success'
						});
						this.$router.replace('/Result');
					} else {
						this.$notify.error({
							title: '错误',
							message: res.message
						});
					}
				})
			},
			// 计时器
			startCountdown() {
				this.intervalId = setInterval(() => {
					if (this.countdown > 0) {
						this.countdown--;
					} else {
						clearInterval(this.intervalId);
						this.saveQuestionPost();
					}
				}, 1000);
			},
			stopCountdown() {
				clearInterval(this.intervalId);
			},
		},
		beforeDestroy() {
			this.stopCountdown(); // 组件销毁前确保清除定时器以防止内存泄漏
		},
	}
</script>

<style scoped>
	.fade-in-linear-enter-active .el-overlay-message-box {
		-webkit-animation: msgbox-fade-in var(--el-transition-duration);
		animation: msgbox-fade-in var(--el-transition-duration)
	}

	.fade-in-linear-leave-active .el-overlay-message-box {
		animation: msgbox-fade-in var(--el-transition-duration) reverse
	}

	@-webkit-keyframes msgbox-fade-in {
		0% {
			transform: translate3d(0, -20px, 0);
			opacity: 0
		}

		to {
			transform: translateZ(0);
			opacity: 1
		}
	}

	@keyframes msgbox-fade-in {
		0% {
			transform: translate3d(0, -20px, 0);
			opacity: 0
		}

		to {
			transform: translateZ(0);
			opacity: 1
		}
	}

	.question-list-area {
		box-sizing: border-box;
		padding: 1.88rem 1.88rem .2rem;
		overflow-y: auto;
		height: calc(100% - 5.38rem)
	}

	.question-list-area .question-grid {
		display: grid;
		grid-template-columns: repeat(5, 1fr);
		column-gap: .88rem;
		row-gap: .88rem
	}

	.question-list-area .question-grid .question-card {
		width: 2.81rem;
		height: 2.81rem;
		background: #f7f7f7;
		border-radius: .31rem;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 1.25rem;
		font-family: PingFang SC-Bold;
		color: #c3c3c3;
		line-height: 1.46rem;
		cursor: pointer;
		-webkit-user-select: none;
		user-select: none;
		transition: .2s all
	}

	.question-list-area .question-grid .question-card:hover {
		transition: .2s all;
		box-shadow: 0 2px 5px 1px #0000001a
	}

	.question-list-area .question-grid .question-card_done {
		background: #4c7bff;
		color: #fff
	}

	.question-list-area .question-grid .question-card_active {
		background: #e6a23c;
		color: #fff
	}

	.sumit-button {
		width: 17.56rem;
		height: 3.5rem;
		background: #4c7bff;
		border-radius: .31rem;
		margin: 0 auto;
		margin-top: 1.2rem;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 1.25rem;
		font-family: PingFang SC-Bold;
		color: #fff;
		line-height: 1.46rem;
		cursor: pointer;
		-webkit-user-select: none;
		user-select: none;
		transition: .2s all
	}

	.sumit-button:hover {
		transition: .2s all;
		box-shadow: 0 3px 5px 1px #0003
	}

	.timer {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%
	}

	.timer .timer-icon {
		width: 1.5rem;
		margin-right: 1rem
	}

	.timer .timer-text {
		font-size: 1.56rem;
		font-family: PingFang SC-Bold;
		color: red;
		line-height: 1.83rem
	}

	.exam {
		height: 100%;
		width: 100%
	}

	.exam .left-side {
		position: absolute;
		top: .94rem;
		left: .94rem;
		height: 100%;
		width: 21.31rem;
		transform: translate(0);
		overflow-y: auto
	}

	.exam .left-side .timer {
		width: 100%;
		height: 4.19rem;
		background: #fff;
		border-radius: .5rem;
		opacity: 1
	}

	.exam .left-side .question-list {
		margin-top: .94rem;
		width: 100%;
		height: calc(100% - 6.07rem);
		background: #fff;
		border-radius: .5rem;
		opacity: 1
	}

	.exam .answer-area {
		position: absolute;
		top: .94rem;
		left: 23.19rem;
		width: 95.88rem;
		border-radius: .5rem;
		height: calc(100% - .94rem);
		background-color: #fff
	}

	.exam-start-info .exam-start-info__item {
		margin-bottom: 2rem;
		display: flex
	}

	.exam-start-info .exam-start-info__item .exam-start-info-item__title {
		font-size: 1.5rem;
		font-family: PingFang SC-Bold;
		color: #333;
		min-width: 6rem
	}

	.exam-start-info .exam-start-info__item .exam-start-info-item__content {
		margin-left: 1rem;
		font-size: 1.25rem;
		font-family: PingFang SC-Regular;
		color: #666;
		line-height: 2rem
	}

	.exam-start-info .start-button {
		width: 17.56rem;
		height: 3.5rem;
		background: #4c7bff;
		border-radius: .31rem;
		margin: 0 auto;
		margin-top: 3rem;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 1.25rem;
		font-family: PingFang SC-Bold;
		color: #fff;
		line-height: 1.46rem;
		cursor: pointer;
		-webkit-user-select: none;
		user-select: none;
		transition: .2s all
	}

	.exam-start-info .start-button:hover {
		transition: .2s all;
		box-shadow: 0 2px 5px 1px #0006
	}

	.exam-result {
		box-sizing: border-box;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		padding: .94rem .94rem 0
	}


	.answering-area {
		box-sizing: border-box;
		width: 100%;
		height: 100%;
		overflow-y: auto
	}

	.answering-area .question-img {
		/* width: 92.13rem; */
		height: auto;
		-webkit-user-select: none;
		user-select: none;
		pointer-events: none;
		margin: 0 auto
	}

	.answering-area .answering {
		box-sizing: border-box;
		margin-top: 3rem;
		width: 100%;
		padding: 0 28.88rem;
		display: grid;
		grid-template-columns: repeat(4, 1fr);
		column-gap: 4.38rem;
		row-gap: 4.38rem
	}

	.answering-area .answering .answering-choice {
		box-sizing: border-box;
		width: 6.25rem;
		height: 6.25rem;
		background: #f4f4f4;
		border-radius: .31rem;
		font-size: 2.5rem;
		font-family: PingFang SC-Bold;
		color: #c6c6c6;
		line-height: 2.93rem;
		display: flex;
		align-items: center;
		justify-content: center;
		transition: .2s all;
		-webkit-user-select: none;
		user-select: none;
		border: .13rem solid #f4f4f4;
		cursor: pointer
	}

	.answering-area .answering .answering-choice:hover {
		transition: .2s all;
		box-shadow: 0 2px 10px 3px #0000001a
	}

	.answering-area .answering .answering-choice_active {
		background: #4c7bff;
		border: .13rem solid #0936b6;
		color: #fff
	}

	.answering-area .pre-next {
		box-sizing: border-box;
		margin-top: 4rem;
		width: 100%;
		padding: 0 30rem;
		display: flex;
		align-items: center;
		/* justify-content: space-around */
	}

	.answering-area .pre-next .pre-next-button {
		width: 12rem;
		height: 3.5rem;
		border-radius: .31rem;
		font-size: 1.25rem;
		font-family: PingFang SC-Bold;
		line-height: 1.46rem;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		-webkit-user-select: none;
		user-select: none;
		transition: .2s all
	}

	.answering-area .pre-next .pre-next-button:hover {
		transition: .2s all;
		box-shadow: 0 2px 5px 3px #0000004d
	}

	.answering-area .pre-next .pre-button {
		border: .13rem solid #828282;
		color: #828282
	}

	.answering-area .pre-next .next-button {
		background: #4c7bff;
		color: #fff;
		margin-left: 5px;
	}

	:root {
		--el-popup-modal-bg-color: var(--el-color-black);
		--el-popup-modal-opacity: .5
	}

	.v-modal-enter {
		-webkit-animation: v-modal-in var(--el-transition-duration-fast) ease;
		animation: v-modal-in var(--el-transition-duration-fast) ease
	}

	.v-modal-leave {
		-webkit-animation: v-modal-out var(--el-transition-duration-fast) ease forwards;
		animation: v-modal-out var(--el-transition-duration-fast) ease forwards
	}

	@-webkit-keyframes v-modal-in {
		0% {
			opacity: 0
		}
	}

	@keyframes v-modal-in {
		0% {
			opacity: 0
		}
	}

	@-webkit-keyframes v-modal-out {
		to {
			opacity: 0
		}
	}

	@keyframes v-modal-out {
		to {
			opacity: 0
		}
	}

	.v-modal {
		position: fixed;
		left: 0;
		top: 0;
		width: 100%;
		height: 100%;
		opacity: var(--el-popup-modal-opacity);
		background: var(--el-popup-modal-bg-color)
	}
</style>